var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-4 reports-tab-container" }, [
      _c("div", { staticClass: "row report-fields-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("reports.disbursement.date"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.dateRange,
                "allow-empty": false,
                "show-labels": false,
              },
              on: { input: _vm.onChangeDateRange },
              model: {
                value: _vm.selectedRange,
                callback: function ($$v) {
                  _vm.selectedRange = $$v
                },
                expression: "selectedRange",
              },
            }),
            _vm._v(" "),
            _vm.$v.range.$error && !_vm.$v.range.required
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row report-fields-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("reports.invoices.from_date"))),
            ]),
            _vm._v(" "),
            _c("base-date-picker", {
              attrs: {
                "calendar-button": true,
                "calendar-button-icon": "calendar",
              },
              on: {
                change: function ($event) {
                  return _vm.$v.formData.due_from_date.$touch()
                },
                input: _vm.setRangeToCustom,
              },
              model: {
                value: _vm.formData.due_from_date,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "due_from_date", $$v)
                },
                expression: "formData.due_from_date",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("reports.invoices.to_date"))),
            ]),
            _vm._v(" "),
            _c("base-date-picker", {
              attrs: {
                "calendar-button": true,
                "calendar-button-icon": "calendar",
              },
              on: {
                change: function ($event) {
                  return _vm.$v.formData.due_to_date.$touch()
                },
                input: _vm.setRangeToCustom,
              },
              model: {
                value: _vm.formData.due_to_date,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "due_to_date", $$v)
                },
                expression: "formData.due_to_date",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.userType == "super_admin"
        ? _c("div", { staticClass: "row report-fields-container" }, [
            _c(
              "div",
              { staticClass: "col-md-6 report-field-container" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$tc("data_exports.reports.suppliers"))),
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    options: _vm.users,
                    "group-select": false,
                    searchable: true,
                    "show-labels": false,
                    placeholder: _vm.$t("suppliers.select_a_supplier"),
                    "group-values": "options",
                    "group-label": "label",
                    "track-by": "id",
                    label: "name",
                  },
                  model: {
                    value: _vm.formData.company_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "company_id", $$v)
                    },
                    expression: "formData.company_id",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 report-field-container" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$tc("data_exports.reports.buyers"))),
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    options: _vm.buyers,
                    "group-select": false,
                    searchable: true,
                    "show-labels": false,
                    placeholder: _vm.$t("clients.select_a_buyer"),
                    "group-values": "options",
                    "group-label": "label",
                    "track-by": "id",
                    label: "name",
                  },
                  model: {
                    value: _vm.formData.buyer_company_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "buyer_company_id", $$v)
                    },
                    expression: "formData.buyer_company_id",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.userType == "supplier"
        ? _c("div", { staticClass: "row report-fields-container" }, [
            _c(
              "div",
              { staticClass: "col-md-6 report-field-container" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$tc("data_exports.reports.buyers"))),
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    options: _vm.customers,
                    "group-select": false,
                    searchable: true,
                    "show-labels": false,
                    placeholder: _vm.$t("clients.select_a_buyer"),
                    "group-values": "options",
                    "group-label": "label",
                    "track-by": "id",
                    label: "name",
                  },
                  model: {
                    value: _vm.formData.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "customer_id", $$v)
                    },
                    expression: "formData.customer_id",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 report-field-container" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$tc("reports.disbursement.bank"))),
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    options: _vm.banks,
                    "group-select": false,
                    searchable: true,
                    "show-labels": false,
                    placeholder: _vm.$t("reports.disbursement.select_a_bank"),
                    "group-values": "options",
                    "group-label": "label",
                    "track-by": "id",
                    label: "name",
                  },
                  model: {
                    value: _vm.formData.funder_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "funder_id", $$v)
                    },
                    expression: "formData.funder_id",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row report-fields-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$tc("data_exports.reports.buyers"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.customers,
                "group-select": false,
                searchable: true,
                "show-labels": false,
                placeholder: _vm.$t("clients.select_a_buyer"),
                "group-values": "options",
                "group-label": "label",
                "track-by": "id",
                label: "name",
              },
              model: {
                value: _vm.formData.customer_id,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "customer_id", $$v)
                },
                expression: "formData.customer_id",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$tc("data_exports.reports.suppliers"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.suppliers,
                "group-select": false,
                searchable: true,
                "show-labels": false,
                placeholder: _vm.$t("suppliers.select_a_supplier"),
                "group-values": "options",
                "group-label": "label",
                "track-by": "id",
                label: "name",
              },
              model: {
                value: _vm.formData.user_id,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "user_id", $$v)
                },
                expression: "formData.user_id",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row report-fields-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("reports.invoices.status"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.statuses,
                "allow-empty": false,
                "show-labels": false,
              },
              on: { input: _vm.onChangeStatus },
              model: {
                value: _vm.selectedStatus,
                callback: function ($$v) {
                  _vm.selectedStatus = $$v
                },
                expression: "selectedStatus",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row report-submit-button-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "base-button",
              {
                staticClass: "report-button",
                attrs: { outline: "", color: "theme" },
                on: {
                  click: function ($event) {
                    return _vm.getReports()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("reports.update_report")) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-8 reports-tab-container" }, [
      _c("iframe", {
        staticClass: "reports-frame-style",
        attrs: { src: _vm.getReportUrl },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "base-button btn btn-primary btn-lg report-view-button",
          on: { click: _vm.viewReportsPDF },
        },
        [
          _c("font-awesome-icon", {
            staticClass:
              "vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2",
            attrs: { icon: "file-pdf" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("reports.view_pdf")))]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }